__turbopack_context__.v({
  "dark": "Tag-module-scss-module__b4dlcq__dark",
  "hoverable": "Tag-module-scss-module__b4dlcq__hoverable",
  "label": "Tag-module-scss-module__b4dlcq__label",
  "light": "Tag-module-scss-module__b4dlcq__light",
  "md": "Tag-module-scss-module__b4dlcq__md",
  "sm": "Tag-module-scss-module__b4dlcq__sm",
  "tag": "Tag-module-scss-module__b4dlcq__tag",
});
